import { defineMessages } from 'react-intl';

export const userMessages = defineMessages({
    signIn: {
        id: 'userMessages.login',
        description: 'SignIn link text',
        defaultMessage: 'Sign-in'
    },
    logout: {
        id: 'userMessages.logout',
        description: 'Logout link text',
        defaultMessage: 'Log out'
    },
    createAccount: {
        id: 'userMessages.createAccount',
        description: 'Create account link text',
        defaultMessage: 'Create Account'
    },
    cardOrders: {
        id: 'userMessages.cardOrders',
        description: 'Card Orders and Balances text',
        defaultMessage: 'Card Orders and Balances'
    },
    pointsAvailable: {
        id: 'userMessages.pointsAvailable',
        description: 'Points available text',
        defaultMessage: 'Available'
    },
    pointsRemaining: {
        id: 'userMessages.pointsRemaining',
        description: 'Points remaining text',
        defaultMessage: 'Remaining'
    },
    userLoading: {
        id: 'userMessages.userLoading',
        description: 'Loading status text',
        defaultMessage: 'Loading...'
    },
    userNotLoggedIn: {
        id: 'userMessages.userNotLoggedIn',
        description: 'Not logged in status text',
        defaultMessage: 'You are not logged in.'
    },
});
